import { Quote, MessageCircle } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { waLink } from "@/lib/site";

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead eyebrow="Customer Testimonials" title={<>Real words from <span className="text-gold-grad italic">real clients</span> — coming soon.</>} intro="We only publish genuine, verified customer reviews. This space is reserved for feedback from our clients as it is received." />
      <div className="mt-16 grid gap-6 md:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <Reveal key={i} delay={i * 0.1} className="h-full">
            <figure data-testid={`testimonial-placeholder-${i}`} className="flex h-full flex-col rounded-3xl border border-dashed border-white/15 bg-white/[0.015] p-8">
              <Quote className="h-8 w-8 text-gold/60" />
              <span className="mt-6 inline-block w-fit rounded-full bg-white/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-slate-300">Placeholder</span>
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-slate-300">
                Verified client review will appear here once supplied by a Pratap Group customer.
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3">
                <span className="h-11 w-11 rounded-full border border-dashed border-white/20" />
                <span>
                  <span className="block text-sm font-medium text-slate-200">Client name</span>
                  <span className="block text-xs text-slate-400">Business name</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal>
        <a href={waLink("Hello Pratap Group, I am a client and would like to share a review of my website.")} target="_blank" rel="noopener noreferrer" data-testid="testimonial-share-review-link" className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-[var(--gold-2)] underline-offset-8 hover:underline">
          <MessageCircle className="h-4 w-4" /> Worked with us? Share your review
        </a>
      </Reveal>
    </div>
  </section>
);
